export default __webpack_public_path__ + "static/media/aboutus.629d7f38.svg";